<template> </template>

<script>
export default {};
</script>

<style lang="scss">
$gray0: #f2f2f2;
$gray1: #e6e6e6;
$gray2: #e0e0e0;
$gray3: #ccc;
$messageBackgroundColor: #fffbd2;
$veryLightBlue: #e0edf4;
$backgroundExtraLight: $gray0;
$borderColorLight: $gray1;
$borderColorMedium: $gray3;

@mixin clearfix() {
	&::after {
		display: block;
		content: '';
		clear: both;
	}
}

/* --------------------------------
	Panel styles
-------------------------------- */

/* Default class */
.Panel {
	@include clearfix;
	@include inset-md;
	@include stack-md;
	// Make it hidable with aria
	&[aria-hidden='true'] {
		display: none;
	}
}

/* --------------------------------
	Variant classes
-------------------------------- */

.Panel--alert {
	//@include callout-style(red);
}

.Panel--plain {
	background-color: #fff;
	border: 0;
	@include inset-md;
	@include breakpoint(medium) {
		padding: 2rem 2.5rem;
	}
}

.Panel--simple {
	border: 0;
	padding: 0;
	margin-left: 0;
	margin-right: 0;
}

.Panel--tight {
	padding: 0.6rem 0.8rem;
	margin: 0;
}

.Panel--plainTight {
	background-color: #fff;
	border: 0;
	padding: 0.6rem 0.8rem;
	margin: 0;
}

.Panel--plainSuperTight {
	background-color: #fff;
	border: 0;
	padding: 0.5rem;
	margin: 0;
}

.Panel--dimmed {
	background-color: $gray1;
}

.Panel--dimmedSuperTight {
	background-color: $gray0;
	border: 0;
	padding: 0.5rem;
	margin: 0;
}

.Panel--simpleWhite {
	background-color: $color-white;
	border: 0;
	padding: 0;
	margin: 0;
}

.Panel--message {
	background: $messageBackgroundColor;
	border: 0;
}

.Panel--section {
	border-top: 4px solid $gray2;
}

.Panel--muted {
	background-color: $color-neutral-0;
	border: 0;
	padding: $space-inset-md;
	@include breakpoint(mediumsmall) {
		padding: $space-inset-md;
	}
	@include breakpoint(medium) {
		padding: $space-inset-lg;
	}
}

.Panel--mutedTight {
	padding: 0.6rem 0.8rem;
}

.Panel--subtle {
	height: 82px;
	overflow-y: auto;
	padding: 0.5rem;
	border: 1px dashed $borderColorLight;
	margin: 0 0 1rem;
	background-color: $color-overlay-white;
	line-height: 1.4;
	&.Panel--tall {
		height: 132px;
	}
}

.Panel--ebirdBackground {
	background-color: $veryLightBlue;
}

.Panel--pageFixedLarge {
	//@include grid-row;
	position: relative;
	max-width: map-get($breakpoints, large);
}

.Panel--ebirdRow {
	//@include grid-row;
	max-width: 1100px;
}

.Panel--white {
	background-color: #fff;
	border: 0;
	padding: 0.5rem 0;
	@include clearfix;
}

.Panel--fullHeight {
	height: 100%;
}

.Panel--cardInverseTight {
	@include u-pts;
	background-color: $backgroundExtraLight;
	border: 2px solid $color-white;
}

.Panel--borderLeft {
	border-left: 1px solid $borderColorMedium;
	[dir='rtl'] & {
		border-left: 0;
		border-right: 1px solid $borderColorMedium;
	}
	@include u-plm;
}

.Panel--sideGutters {
	@include u-plm;
	@include u-prm;
}

/* Primary light variant - adds background-color of color-primary-0 */
.Panel--primaryLight {
	@include bg-primary-light;
}

/* Neutral light variant - adds background-color of color-neutral-0 */
.Panel--neutralLight {
	@include bg-neutral-light;
}

/* Neutral light variant - adds background-color of color-neutral-00 */
.Panel--neutralLightest {
	background-color: $color-neutral-0;
}

/* Overlay black variant - adds background-color of color-overlay-black */
.Panel--overlayBlack {
	@include bg-overlay-black;
}

/* Credit variant - tight padding, no margin, for credits under media */
.Panel--credit {
	margin: 0;
	@include inset-xs;
}

/* borderLeftRight variant - initially for speciesEditor header article status */
.Panel--borderLeftRight {
	border-left: 0.05rem solid $color-neutral-1;
	border-right: 0.05rem solid $color-neutral-1;
}

/* top centered */
.Panel--topCenterOverlay {
	position: absolute;
	top: 0;
	left: 50%;
	margin-top: 1rem;
	transform: translateX(-50%);
	z-index: 1000;
}

/* drop shadow */
.Panel--dropShadow-1 {
	@include dropshadow-1;
	border-radius: $radius-sm;
}

.Panel--dropShadow-2 {
	@include dropshadow-2;
	border-radius: $radius-sm;
}

.Panel--dropShadow-3 {
	@include dropshadow-3;
	border-radius: $radius-sm;
}

.Panel--dropShadow-4 {
	@include dropshadow-4;
	border-radius: $radius-sm;
}
</style>
